var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-price-info"},[_c('div',{staticClass:"product-price-info__desc"},[_c('p',[_vm._v(_vm._s(_vm.$t('Pickup price')))])]),_c('img',{attrs:{"src":require("@/assets/images/icons/warehouse.svg"),"alt":_vm.$t('Pickup price')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }